import React from 'react'
import {Modal} from '@thryvlabs/maverick'
import {useNavigate} from 'react-router'

export const AccountFailedModalComponent = ({
  linkId,
  retryLimit,
  currentErrorStep,
  handleModalClose,
}) => {
  const navigate = useNavigate()

  return (
    <div
      className="modal-body"
      style={{height: '200px !important', width: 'auto'}}
    >
      <Modal
        altBtn={<></>}
        openOnLoad
        variant="default"
        modalClassNames="account-failed-modal"
        footer
        action
        btnAction={() => {
          if (currentErrorStep === 'accountCreationStep') {
            handleModalClose()
          }
          if (currentErrorStep !== 'accountCreationStep') {
            navigate(-1)
          }
        }}
        btnActionText={
          currentErrorStep === 'accountCreationStep' ? 'Refresh' : 'OK'
        }
        hideX
        disableX
        disableBackdropClick
        btnType={'primary'}
        modalTestId="account-creation-failed-modal"
      >
        <div
          style={{
            padding: '10px 20px',
            textAlign: 'center',
            overflow: 'hidden',
          }}
        >
          <h3
            style={{
              color: '#FF5000',
              marginBottom: '12px',
              fontSize: '20px',
              fontWeight: '600',
            }}
          >
            {currentErrorStep === 'accountCreationStep'
              ? `Thanks for your patience!`
              : `Almost there!`}
          </h3>
          <p
            style={{
              whiteSpace: 'pre-wrap',
              marginTop: '16px',
              marginBottom: '16px',
              color: '#333',
              fontSize: '14px',
              lineHeight: '1.6',
            }}
          >
            {currentErrorStep === 'accountCreationStep'
              ? `We’re just finishing up a few tasks in the background.
If your screen doesn’t refresh automatically in the next few moments, please click the Refresh button below.`
              : `It looks like things just need a little extra help. While everything
            finishes lining up behind the scenes, please reach out to your
            Business Consultant — they’ll be happy to help move things along.
          `}
          </p>
        </div>
      </Modal>
    </div>
  )
}
